import React from 'react'

import { Stack } from 'component-library-next'

import { ProfessionalAuditOutcome } from '@app/graphql/types'

export type AuditReportClauseEffectivenessProps = {
  topicName: string
  effectiveness: ProfessionalAuditOutcome
}

export const AuditReportClauseEffectiveness = ({
  topicName,
  effectiveness
}: AuditReportClauseEffectivenessProps) => {
  const effectiveBottomLineLabels = {
    Nebenkosten: 'Nebenkostenabrechnung korrekt!',
    Renovieren: 'Renovierungsklauseln wirksam!',
    Schönheitsreparaturen: 'Renovierungsklauseln wirksam!'
  }

  const ineffectiveBottomLineLabels = {
    Nebenkosten: 'Nebenkostenabrechnung fehlerhaft!',
    Renovieren: 'Renovierungsklauseln unwirksam!',
    Schönheitsreparaturen: 'Renovierungsklauseln unwirksam!'
  }

  const result =
    effectiveness === ProfessionalAuditOutcome.Pass
      ? effectiveBottomLineLabels[topicName]
      : ineffectiveBottomLineLabels[topicName]

  return (
    <Stack gap={Stack.gap.small}>
      <div className='audit-report__heading'>Ergebnis im Überblick</div>
      <p className='audit-report__text'>{result}</p>
    </Stack>
  )
}
